import { render, staticRenderFns } from "./allInvestments.vue?vue&type=template&id=6187591e&"
import script from "./allInvestments.vue?vue&type=script&lang=js&"
export * from "./allInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports